import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=44911554&scoped=true&"
import script from "./ModuleEdit.vue?vue&type=script&lang=js&"
export * from "./ModuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44911554",
  null
  
)

export default component.exports